import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadMonitoringIssueDocument: IMonitoringIssueDocumentLoadActionCreator = () => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_LOAD
        }
    },
    LoadMonitoringIssueDocumentsByMonitoringIssueId: IMonitoringIssueDocumentsLoadByMonitoringIssueIdActionCreator = (monitoringIssueId) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID,
            monitoringIssueId
        }
    },
    LoadMonitoringIssueDocumentById: IMonitoringIssueDocumentLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IMonitoringIssueDocumentLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IMonitoringIssueDocumentLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveMonitoringIssueDocument: IMonitoringIssueDocumentSaveActionCreator = (formData) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_SAVE,
            formData
        }
    },
    SaveSuccess: IMonitoringIssueDocumentSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IMonitoringIssueDocumentSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateMonitoringIssueDocument: IMonitoringIssueDocumentCreateActionCreator = (monitoringIssueId) => {

        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_CREATE,
            monitoringIssueId
        }
    },
    CreateSuccess: IMonitoringIssueDocumentCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IMonitoringIssueDocumentCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateMonitoringIssueDocument: IMonitoringIssueDocumentValidateActionCreator = (formData) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IMonitoringIssueDocumentValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IMonitoringIssueDocumentValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IMonitoringIssueDocumentClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_CLEAR,
            propertiesToClear
        }
    },

    Filter: IMonitoringIssueDocumentFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_MONITORINGISSUEDOCUMENT_FILTER,
            formFilter
        }
    };



export const
    ACTION_MONITORINGISSUEDOCUMENT_LOAD = "ACTION_MONITORINGISSUEDOCUMENT_LOAD",
    ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID = "ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID",
    ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID = "ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID",
    ACTION_MONITORINGISSUEDOCUMENT_LOAD_SUCCESS = "ACTION_MONITORINGISSUEDOCUMENT_LOAD_SUCCESS",
    ACTION_MONITORINGISSUEDOCUMENT_LOAD_FAILURE = "ACTION_MONITORINGISSUEDOCUMENT_LOAD_FAILURE",

    ACTION_MONITORINGISSUEDOCUMENT_SAVE = "ACTION_MONITORINGISSUEDOCUMENT_SAVE",
    ACTION_MONITORINGISSUEDOCUMENT_SAVE_SUCCESS = "ACTION_MONITORINGISSUEDOCUMENT_SAVE_SUCCESS",
    ACTION_MONITORINGISSUEDOCUMENT_SAVE_FAILURE = "ACTION_MONITORINGISSUEDOCUMENT_SAVE_FAILURE",

    ACTION_MONITORINGISSUEDOCUMENT_CREATE = "ACTION_MONITORINGISSUEDOCUMENT_CREATE",
    ACTION_MONITORINGISSUEDOCUMENT_CREATE_SUCCESS = "ACTION_MONITORINGISSUEDOCUMENT_CREATE_SUCCESS",
    ACTION_MONITORINGISSUEDOCUMENT_CREATE_FAILURE = "ACTION_MONITORINGISSUEDOCUMENT_CREATE_FAILURE",

    ACTION_MONITORINGISSUEDOCUMENT_VALIDATE = "ACTION_MONITORINGISSUEDOCUMENT_VALIDATE",
    ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_SUCCESS = "ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_SUCCESS",
    ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_FAILURE = "ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_FAILURE",

    ACTION_MONITORINGISSUEDOCUMENT_CLEAR = "ACTION_MONITORINGISSUEDOCUMENT_CLEAR",

    ACTION_MONITORINGISSUEDOCUMENT_FILTER = "ACTION_MONITORINGISSUEDOCUMENT_FILTER";

export interface IMonitoringIssueDocumentLoadAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_LOAD";
}

export interface IMonitoringIssueDocumentLoadActionCreator {
    (): IMonitoringIssueDocumentLoadAction;
}

export interface IMonitoringIssueDocumentLoadSuccessAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_LOAD_SUCCESS";
    formData: Dtos.MonitoringIssueDocument | Dtos.MonitoringIssueDocument[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueDocumentLoadSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssueDocument | Dtos.MonitoringIssueDocument[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringIssueDocumentLoadSuccessAction;
}

export interface IMonitoringIssueDocumentLoadFailureAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueDocumentLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentLoadFailureAction;
}

export interface IMonitoringIssueDocumentsLoadByMonitoringIssueIdAction {
    type: "ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID";
    monitoringIssueId: number;
}

export interface IMonitoringIssueDocumentsLoadByMonitoringIssueIdActionCreator {
    (monitoringIssueId: number): IMonitoringIssueDocumentsLoadByMonitoringIssueIdAction;
}

export interface IMonitoringIssueDocumentLoadByIdAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID";
    id: number;
}

export interface IMonitoringIssueDocumentLoadByIdActionCreator {
    (id: number): IMonitoringIssueDocumentLoadByIdAction;
}


export interface IMonitoringIssueDocumentSaveAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_SAVE";
    formData: Dtos.MonitoringIssueDocument;

}

export interface IMonitoringIssueDocumentSaveActionCreator {
    (
        formData: Dtos.MonitoringIssueDocument
    ): IMonitoringIssueDocumentSaveAction;
}

export interface IMonitoringIssueDocumentSaveSuccessAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_SAVE_SUCCESS";
    formData: Dtos.MonitoringIssueDocument;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueDocumentSaveSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssueDocument,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringIssueDocumentSaveSuccessAction;
}

export interface IMonitoringIssueDocumentSaveFailureAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringIssueDocumentSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentSaveFailureAction;
}

export interface IMonitoringIssueDocumentCreateAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_CREATE",
    monitoringIssueId: number
}

export interface IMonitoringIssueDocumentCreateActionCreator {
    (monitoringIssueId: number): IMonitoringIssueDocumentCreateAction
}

export interface IMonitoringIssueDocumentCreateSuccessAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_CREATE_SUCCESS";
    formData: Dtos.MonitoringIssueDocument;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IMonitoringIssueDocumentCreateSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssueDocument,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IMonitoringIssueDocumentCreateSuccessAction;
}

export interface IMonitoringIssueDocumentCreateFailureAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringIssueDocumentCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentCreateFailureAction;
}

export interface IMonitoringIssueDocumentValidateAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_VALIDATE";
    formData: Dtos.MonitoringIssueDocument;

}

export interface IMonitoringIssueDocumentValidateActionCreator {
    (
        formData: Dtos.MonitoringIssueDocument
    ): IMonitoringIssueDocumentValidateAction;
}

export interface IMonitoringIssueDocumentValidateSuccessAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_SUCCESS";
    formData: Dtos.MonitoringIssueDocument;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IMonitoringIssueDocumentValidateSuccessActionCreator {
    (
        formData: Dtos.MonitoringIssueDocument,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IMonitoringIssueDocumentValidateSuccessAction;
}

export interface IMonitoringIssueDocumentValidateFailureAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IMonitoringIssueDocumentValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMonitoringIssueDocumentValidateFailureAction;
}

export interface IMonitoringIssueDocumentClearAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_CLEAR";
    propertiesToClear?: string[];
}

export interface IMonitoringIssueDocumentClearActionCreator {
    (propertiesToClear?: string[]): IMonitoringIssueDocumentClearAction;
}

export interface IMonitoringIssueDocumentFilterActionCreator {
    (formFilter: IFormFilter): IMonitoringIssueDocumentFilterAction;
}

export interface IMonitoringIssueDocumentFilterAction {
    type: "ACTION_MONITORINGISSUEDOCUMENT_FILTER";
    formFilter: IFormFilter;
}

export type MonitoringIssueDocumentAction =
    IMonitoringIssueDocumentLoadAction |
    IMonitoringIssueDocumentsLoadByMonitoringIssueIdAction |
    IMonitoringIssueDocumentLoadByIdAction |
    IMonitoringIssueDocumentLoadFailureAction |
    IMonitoringIssueDocumentLoadSuccessAction |
    IMonitoringIssueDocumentSaveAction |
    IMonitoringIssueDocumentSaveSuccessAction |
    IMonitoringIssueDocumentSaveFailureAction |
    IMonitoringIssueDocumentCreateAction |
    IMonitoringIssueDocumentCreateSuccessAction |
    IMonitoringIssueDocumentCreateFailureAction |
    IMonitoringIssueDocumentValidateAction |
    IMonitoringIssueDocumentValidateSuccessAction |
    IMonitoringIssueDocumentValidateFailureAction |
    IMonitoringIssueDocumentClearAction | 
    IMonitoringIssueDocumentFilterAction;
